<template>

  <div class="overlayDiv">

    <span>{{ getAddress }}</span>

    <br/>  <br/>

    <div class="business-hours" v-html="getBusinessHours"></div>
  </div>
</template>

<script>
export default {
  name: "HomeData",
  computed: {
    getAddress() {
      return this.$store.getters.getSettingValue("ShopAddress")
    },
    getBusinessHours() {
      const businessHours = this.$store.getters.getSettingValue("businessHours")

      return this.sanitizeBusinessHours(businessHours)
    }
  },
  methods: {
    sanitizeBusinessHours(value) {
      if (!value) {
        return ''
      }

      const container = document.createElement('div')
      container.innerHTML = String(value).replace(/\n/g, '<br>')

      const allowedTags = ['B', 'STRONG', 'I', 'EM', 'BR', 'P', 'DIV', 'SPAN']
      const allowedTextAlign = ['left', 'center', 'right']
      const allowedColor = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

      container.querySelectorAll('*').forEach(element => {
        if (!allowedTags.includes(element.tagName)) {
          element.replaceWith(document.createTextNode(element.textContent))
          return
        }

        Array.from(element.attributes).forEach(attribute => {
          const name = attribute.name.toLowerCase()
          const value = attribute.value.toLowerCase().trim()

          if (name !== 'style') {
            element.removeAttribute(attribute.name)
            return
          }

          const safeStyles = []

          value.split(';').forEach(style => {
            const [property, propertyValue] = style.split(':').map(part => part && part.trim())

            if (property === 'text-align' && allowedTextAlign.includes(propertyValue)) {
              safeStyles.push(`${property}: ${propertyValue}`)
            }

            if (property === 'color' && allowedColor.test(propertyValue)) {
              safeStyles.push(`${property}: ${propertyValue}`)
            }
          })

          if (safeStyles.length) {
            element.setAttribute('style', safeStyles.join('; '))
          } else {
            element.removeAttribute(attribute.name)
          }
        })
      })

      return container.innerHTML
    }
  }
}
</script>

<style scoped>
.overlayDiv {
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3); /* Fondo negro semi-transparente */
  padding: 20px;
  color: white; /* Color del texto */
  border-radius: 5px;
}
</style>
